import React from 'react'
import { Button, Header, Form, Icon, Tab } from 'semantic-ui-react'
import Details from './thePlace/details'
import Images from './thePlace/images'
import Messages from '../Messages.js'
import { languages } from '../../constants'
import PermissionsManager from '../PermissionsManager'

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = {obj: obj, language: language, onChange: onChange}
    return {menuItem: language.label, render: () => <Tab.Pane key={language.code} attached={false}><Details {...attrs} /></Tab.Pane>}
  })

  panes.push({menuItem: 'Gestion des images', render: () => <Tab.Pane attached={false}><Images obj={obj} onChange={onChange} /></Tab.Pane>})

  return panes
}

const ThePlaceForm = ({ obj, status, onChange, onSubmit, onDelete }) => {

  return (
    <Form>
      <Header>Le lieu</Header>
      <Messages errors={status.errors} messages={status.messages} />
      <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange)} />
      <br /><br />
      <Form.Field>
        <PermissionsManager hasPermissions={['update_the_place']}>
          {status.loading ? <Button type='submit' floated='left' color='red' loading> Chargement...</Button> :
            <Button type='submit' floated='left' color='olive' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
          }
        </PermissionsManager>
      </Form.Field>
    </Form>
  )
}

export default ThePlaceForm



// WEBPACK FOOTER //
// ./src/components/form/ThePlace.js